export default {"src":"/_next/static/media/threejs.b7882dd5.svg","height":227,"width":227,"blurWidth":0,"blurHeight":0};